import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import breakpoints from '../theme/material/breakpoints';
import colors, { primaryBG } from '../theme/colors';
import { getTextColor } from '../style';
import { FONT_FAMILIES } from '../theme/material/constants';
import Button from '../atoms/buttons/Button';

export const StyledLoginContainer = styled('div')({
  [breakpoints.down('sm')]: {
    marginBottom: 22,
  },
});

export const loginPanelStyle = {
  margin: '0px 0px',
  backgroundColor: '#FFF',
  border: '1px solid rgb(218, 225, 233)',
  minHeight: 475,
  borderRadius: '5px',
  position: 'relative',
  boxShadow: 'none',
  placeContent: 'center',
  padding: '30px 92px',

  [breakpoints.down('md')]: {
    padding: '45px',
  },

  [breakpoints.down('xs')]: {
    margin: '0px 5px',
    padding: '20px 15px',
  },
};

export const HeadlineContainer = styled('div')(() => ({
  textAlign: 'center',
  ...getTextColor().BRAND,
}));

export const Headline = styled('h1')({
  margin: 0,
  display: 'inline-block',
  color: colors.light.blue.primary,
  fontWeight: 700,
  fontSize: 22,
  lineHeight: '24px',
  letterSpacing: '-0.3px',
});

export const StepText = styled(Typography)({
  display: 'inline-block',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '21px',
  letterSpacing: '-0.3px',
  color: colors.light.gray.light,
});

export const ButtonWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
  maxWidth: 315,
  paddingTop: '20px',
  paddingBottom: '20px',
  margin: 'auto',
});

export const SSOButtonWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
  maxWidth: 315,
  margin: 'auto',
});

export const NextButtonWrapper = styled('div')({
  textAlign: 'center',
  marginBottom: 20,
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const ContinueButton = styled(Button)(() => ({
  background: colors.gray['100'],
  border: `1px solid ${colors.gray['1200']}`,
  borderRadius: '4px',
  fontSize: '14px !important',
  fontWeight: 400,
  fontFamily: FONT_FAMILIES.primary,
  lineHeight: '16px',
  letterSpacing: '-0.28px',
  width: '100%',
  height: 40,
  color: colors.light.gray.light,
}));

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const BottomWrapper = styled('div')(() => ({
  textAlign: 'center',
  fontSize: 14,
  fontWeight: 400,
  color: colors.gray['1000'],
  letterSpacing: '-0.3px',
}));

export const textLinkStyle = {
  color: colors.light.blue.primary,
  textDecoration: 'underline',
  fontWeight: 700,
  textUnderlinePosition: 'under',
};

export const buttonStyle = {
  fontFamily: FONT_FAMILIES.primary,
  margin: '0 auto',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16px',
  padding: '12px 22px',
  minWidth: '192px',
  '&:disabled': {
    background: '#DEDEDE !important',
    border: 'none !important',
    color: '#fff !important',
  },
  borderRadius: '4px !important',
  marginBottom: 15,
};

export const emailLabelStyle = {
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  color: colors.light.gray.light,
};

export const emailStatusStyle = {
  textAlign: 'center' as const,
  color: colors.light.warning.primary,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '-0.28px',
  marginTop: 6,
};

export const emailInputStyle = {
  fontSize: '15px !important',
  fontWeight: 400,
  lineHeight: '20px !important',
  letterSpacing: '-0.3px',
  color: `${colors.light.gray.light} !important`,
  background: `${primaryBG} !important`,
};

export const forgotLinkStyle = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '17px',
  textDecoration: 'underline',
  color: colors.light.blue.primary,
  marginBottom: 20,
  display: 'inline-block',
  textUnderlinePosition: 'under',
};

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const BottomLinkWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
}));

export const PipeStyle = styled('div')(() => ({
  margin: '2px 15px 0 15px',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '17px',
  color: colors.light.gray.light,
}));

export const phoneInputLabelStyle = {
  fontSize: 15,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  color: colors.light.gray.light,
};

export const phoneInputStyle = {
  color: colors.light.gray.light,
  borderRadius: '3px',
  fontSize: 16,
  lineHeight: '24px',
  fontFamily: FONT_FAMILIES.primary,
  height: 40,
};

export const HCaptchaContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 20,
});

export const resendPasscodeText = {
  fontSize: 15,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  color: colors.gray['1000'],
  marginRight: 3,
};

export const resendPasscodeLinkStyle = {
  fontSize: 15,
  lineHeight: '20px',
  textDecoration: 'underline',
  letterSpacing: '-0.3px',
  fontWeight: 400,
  textUnderlinePosition: 'under',
};

export const OrTextStyle = styled('p')({
  color: '#000',
  fontSize: 15,
  fontWeight: 700,
  lineHeight: '16px',
  marginBottom: 20,
});

export const GenericErrorContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 15,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  background: '#FFEAEC',
  marginTop: 20,
  gap: 10,
});

export const GenericErrorMessage = styled('p')({
  color: colors.light.warning.primary,
  textAlign: 'center',
  leadingTrim: 'both',
  fontSize: 16,
  fontFamily: FONT_FAMILIES.primary,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '21px' /* 131.25% */,
  letterSpacing: '-0.32px',
  margin: 0,
});

export const GenericSuccessContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 15,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  background: colors.light.green.primary,
  marginTop: 20,
  gap: 10,
});

export const GenericSuccessMessage = styled('p')({
  color: '#fff',
  textAlign: 'center',
  leadingTrim: 'both',
  fontSize: 14,
  fontFamily: FONT_FAMILIES.primary,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '21px' /* 131.25% */,
  letterSpacing: '-0.32px',
  margin: 0,
});

export const GenericInfoContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 15,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  background: '#e6f4fd',
  marginTop: 20,
  gap: 10,
});

export const GenericInfoMessage = styled('p')({
  textAlign: 'center',
  leadingTrim: 'both',
  fontSize: 14,
  fontFamily: FONT_FAMILIES.primary,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '21px' /* 131.25% */,
  letterSpacing: '-0.32px',
  margin: 0,
});

export const forgotMsgContactLink = {
  color: colors.light.warning.primary,
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'none',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',
};
